import React from 'react';
import _capitalize from 'lodash/capitalize';
import { Form, Radio, Select, Input } from 'antd';

import { FORM_FIELDS, INVENTORY_TYPES, LIMITED_AD_TRACKING_OPTIONS } from '../../constants';
import { StyledFieldsWrapper } from '../styles';

export const DeviceParameters = (props) => {
  const {
    inventoryTypeValue,
    supplySource,
    isInventoryTypeDisabled,
    handleChangeInventoryType,
    isDeviceFamilyDisabled,
    handleChangeField,
    getOptionsByFieldName,
    renderOptions,
  } = props;
  return (
    <StyledFieldsWrapper>
      <Form.Item
        label={FORM_FIELDS.INVENTORY_TYPE.label}
        name={FORM_FIELDS.INVENTORY_TYPE.name}
        valuePropName="checked"
      >
        <Radio.Group value={inventoryTypeValue} disabled={!supplySource || isInventoryTypeDisabled}>
          {INVENTORY_TYPES.map(({ value, label }) => (
            <Radio
              value={value}
              key={value}
              checked={_capitalize(inventoryTypeValue) === value}
              onChange={handleChangeInventoryType}
            >
              {label}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.DEVICE_FAMILY.label} name={FORM_FIELDS.DEVICE_FAMILY.name}>
        <Select
          placeholder="Select"
          disabled={!supplySource || isDeviceFamilyDisabled}
          allowClear
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.DEVICE_FAMILY.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.DEVICE_FAMILY.name).map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.BRAND.label} name={FORM_FIELDS.BRAND.name}>
        <Select
          placeholder="Select"
          allowClear
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.BRAND.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.BRAND.name).map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.FORM_FACTOR.label} name={FORM_FIELDS.FORM_FACTOR.name}>
        <Select
          placeholder="Select"
          allowClear
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.FORM_FACTOR.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.FORM_FACTOR.name).map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.DEVICE_CATEGORY.label} name={FORM_FIELDS.DEVICE_CATEGORY.name}>
        <Select
          placeholder="Select"
          allowClear
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.DEVICE_CATEGORY.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.DEVICE_CATEGORY.name).map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.IFA_TYPE.label} name={FORM_FIELDS.IFA_TYPE.name}>
        <Select
          placeholder="Select"
          disabled={!supplySource}
          allowClear
          onChange={(value) => handleChangeField({ fieldName: FORM_FIELDS.IFA_TYPE.name, value })}
        >
          {getOptionsByFieldName(FORM_FIELDS.IFA_TYPE.name).map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.USER_AGENT.label} name={FORM_FIELDS.USER_AGENT.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.LIMITED_AD_TRACKING.label} name={FORM_FIELDS.LIMITED_AD_TRACKING.name}>
        <Radio.Group options={LIMITED_AD_TRACKING_OPTIONS} />
      </Form.Item>
    </StyledFieldsWrapper>
  );
};
